import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Alert, Card, Field, btn, input, msg } from "./common";

function Company({ c, canAdmin, onChange }) {
  const [lic, setLic] = useState("");
  const [err, setErr] = useState("");
  const run = (p) => p.then((r) => { setErr(""); onChange(r.data); }).catch((e) => setErr(msg(e)));
  return (
    <Card testid={`wf-company-${c.id}`} className="space-y-2">
      <div className="flex flex-wrap justify-between gap-2"><strong>{c.name}</strong>
        <span data-testid={`wf-company-status-${c.id}`}>{c.onboarding_complete ? "Onboarding complete" : "Onboarding incomplete"}</span></div>
      <ul>{c.checklist.map((i) => (
        <li key={i.key} data-testid={`wf-check-${c.id}-${i.key}`}>{i.done ? "Done" : "Open"} — {i.label}
          {i.key === "license" && c.license && <span> ({c.license.number}: {c.license.label})</span>}</li>))}</ul>
      <div className="flex flex-wrap gap-2 items-end">
        <button type="button" className={btn} onClick={() => run(api.patch(`/workforce/companies/${c.id}/onboarding`, { w9_on_file: !c.w9_on_file }))} data-testid={`wf-w9-${c.id}`}>
          {c.w9_on_file ? "Mark W-9 not on file" : "Mark W-9 on file"}</button>
        <Field id={`wf-lic-${c.id}`} label="License number (self-reported)">
          <input id={`wf-lic-${c.id}`} className={input} value={lic} onChange={(e) => setLic(e.target.value)} data-testid={`wf-lic-${c.id}`} /></Field>
        <button type="button" className={btn} onClick={() => run(api.patch(`/workforce/companies/${c.id}/onboarding`, { license_number: lic }))} data-testid={`wf-lic-save-${c.id}`}>Save license</button>
        {canAdmin && c.license?.status === "self_reported" && (
          <button type="button" className={btn} onClick={() => run(api.post(`/workforce/companies/${c.id}/license/verify`, { note: "Checked with the licensing board" }))} data-testid={`wf-lic-verify-${c.id}`}>Mark verified</button>)}
      </div>
      <Alert text={err} testid={`wf-company-error-${c.id}`} />
    </Card>
  );
}

export default function Companies({ canAdmin }) {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get("/workforce/companies").then((r) => setRows(r.data)).catch((e) => setErr(msg(e))), []);
  useEffect(() => { load(); }, [load]);
  const replace = (c) => setRows((rs) => rs.map((x) => (x.id === c.id ? c : x)));
  return (
    <section className="space-y-3" data-testid="wf-companies">
      <h2 className="font-heading text-lg">Subcontractor companies</h2>
      <p className="text-xs">Insurance comes from the certificates recorded in Safety &amp; Compliance. License numbers stay "self-reported" until another person verifies them.</p>
      <Alert text={err} testid="wf-companies-error" />
      {rows.map((c) => <Company key={c.id} c={c} canAdmin={canAdmin} onChange={replace} />)}
    </section>
  );
}
